import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import { LockOutlined, PersonOutline } from "@mui/icons-material";
import { authService } from "../services/api";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username) {
      setError("Por favor, ingresa tu nombre de usuario");
      return;
    }

    if (!password) {
      setError("Por favor, ingresa la contraseña");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await authService.login(username, password);

      if (response.success) {
        onLogin(response.token, response.user);
      } else {
        setError("Credenciales incorrectas");
      }
    } catch (error) {
      setError(error.message || "Error al verificar las credenciales");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 64px)",
        padding: 2,
      }}
    >
      <Card sx={{ maxWidth: 500, width: "100%" }}>
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <LockOutlined sx={{ fontSize: 48, color: "primary.main" }} />
          </Box>

          <Typography variant="h5" align="center" gutterBottom>
            Bienvenido al Sistema FTP
          </Typography>

          <Typography variant="body1" align="center" sx={{ mb: 3 }}>
            Ingresa tus credenciales para acceder al sistema
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              id="login-username"
              label="Usuario"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                setError("");
              }}
              fullWidth
              margin="normal"
              variant="outlined"
              disabled={loading}
              autoFocus
              autoComplete="username"
              InputProps={{
                startAdornment: (
                  <PersonOutline sx={{ mr: 1, color: "text.secondary" }} />
                ),
              }}
            />

            <TextField
              id="login-password"
              label="Contraseña"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              fullWidth
              margin="normal"
              variant="outlined"
              disabled={loading}
              autoComplete="current-password"
              InputProps={{
                startAdornment: (
                  <LockOutlined sx={{ mr: 1, color: "text.secondary" }} />
                ),
              }}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              sx={{ mt: 2 }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Ingresar"
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
